import { isFlagEnabled } from "js/utilities";
import { getPaymentProfileApi } from "./getPaymentProfileApi";
import { getPolicyPaymentProfile } from "./getPolicyPaymentProfile";

export default isFlagEnabled("ENABLE_RECURRING_PAYMENTS")
  ? getPaymentProfileApi
  : getPolicyPaymentProfile;
